import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import classnames from 'classnames';

import { Page, EventBusBridge, TrackingWrapper } from '@piggybank/core';
import { Route, Switch } from 'react-router-dom';
import { Router } from 'react-router';

import EndUserMonitoring from '~/components/EndUserMonitoring';

import Landing from '~/pages/1_Landing';
import ErrorPage from '~/pages/ErrorPage';

import nls from '~/nls/App';
import { createTranslator } from '~/lib/nls-helper';

import { isMobile } from '~/genericFunctions';
import styles from './App.module.css';

import getEnvironment from './lib/environment';

import getSpecs from '~/lib/tealium/spec';
import { link, view } from '~/lib/tealium/actions';

const NLS = createTranslator(nls);

const setPageTitle = () => {
  document.title = NLS`Products for you - HSBC`;
};

class App extends Component {
  static propTypes = {
    globalData: PropTypes.objectOf(PropTypes.string),
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
    offerData: PropTypes.shape({
      offers: PropTypes.arrayOf(
        PropTypes.shape({
          banner: PropTypes.shape({
            background: PropTypes.shape({
              color: PropTypes.string,
              image: PropTypes.string,
            }),
            textMap: PropTypes.shape({
              title: PropTypes.string,
              text: PropTypes.string,
            }),
            button: PropTypes.shape({
              url: PropTypes.string,
            }),
          }),
        })
      ),
    }),
  };

  componentDidMount () {
    setPageTitle();
  }

  renderOffersJourney (initialData, classes) {
    return (
      <div className={classes}>
        <Router basename="/" history={this.props.history}>
          <Switch>
            <Route exact path="/" render={(props) => <Landing {...props} values={initialData} />} />
            <Route render={() => <ErrorPage globalData={this.props.globalData} />} />
          </Switch>
        </Router>
      </div>
    );
  }

  renderDesktopJourney (initialData, classes) {
    return (
      <Page>
        { this.renderOffersJourney(initialData, classes) }
      </Page>
    );
  }

  renderMobileJourney (initialData, classes) {
    const Empty = () => (
      <div />
    );
    return (
      <Page footerSlot={<Empty />} headerSlot={<Empty />}>
        { this.renderOffersJourney(initialData, classes) }
      </Page>
    );
  }

  render () {
    const environment = getEnvironment();

    const track = event => {
      if (get(environment, 'tealium.isEnabled') && event) {
        const { content } = event;
        const isViewEvent = !!get(event, 'rule.isViewEvent');
        isViewEvent? view(content): link(content);
      }
    };
    let initialData = {
      globalData: this.props.globalData,
      data: this.props.offerData,
    };
    return (
      <>
        <EndUserMonitoring
          appDynamicsApplicationKey={get(environment, 'appDynamics.applicationKey')}
          enabled={get(environment, 'appDynamics.isEnabled')}
        />
        <TrackingWrapper
          onTrackingEvent={events => events.map(e => track(e))}
          specs={getSpecs({ lang: get(this.props.globalData, 'locale') })}
        >
          <EventBusBridge>
            {isMobile(get(this.props.globalData, 'ismobile'))?
              this.renderMobileJourney(initialData, classnames(styles.mobile)):
              this.renderDesktopJourney(initialData, classnames(null))}
          </EventBusBridge>
        </TrackingWrapper>
      </>
    );
  }
}

export default App;
